import { Injectable, signal } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormErrorsService {
    public errors = signal<string>('');
    public httpErrors$: BehaviorSubject<
        { field_name: string; msg: string }[] | undefined
    > = new BehaviorSubject(undefined);

    public setHttpErrors(errors): void {
        this.httpErrors$.next(errors);
    }

    public handleHttpErrors(form: FormGroup) {
        const errors: { [key: string]: string | undefined } = {};
        this.httpErrors$.value?.forEach((error) => {
            if (
                form.controls['passwordGroup'] &&
                form.controls['passwordGroup']['controls'][error.field_name]
            ) {
                const control: FormControl =
                    form.controls['passwordGroup']['controls'][
                        error.field_name
                    ];
                control.setErrors({ incorrect: true });
                control.valueChanges.subscribe(() => {
                    errors[error.field_name] = undefined;
                });
            } else if (form.controls[error.field_name]) {
                form.controls[error.field_name]?.setErrors({ incorrect: true });
                form.controls[error.field_name].valueChanges.subscribe(() => {
                    errors[error.field_name] = undefined;
                });
            }
            errors[error.field_name] = error.msg;
        });
        return errors;
    }
}
